
import { Component, Vue } from 'vue-property-decorator';
import { getDeptSerPriceStatistics, exportDeptSerPriceStatistics } from '@/api/statisticsDeptSerPrice';
import { UserModule } from '../../store/modules/user';
// import DialogCustomer from "@/components/CustomerDialog/levelByLevel.vue";
import FaultDialog from '@/components/FaultDialog/index.vue';

@Component({
  name: 'StatisticsDeptSerPrice',
  components: {
    FaultDialog
  }
})
export default class extends Vue {
  private formSearch:any = {
    name: '',
    timePeriods: '',
    fualtType: {}
  }
  // private pickerOptions:any = {
  //   disabledDate(time: any) {
  //     let y = new Date().getFullYear();
  //     let m = new Date().getMonth();
  //     let d = new Date().getDate();
  //     return time.getTime() >= new Date(y, m, d, 0, 0, 0);
  //   }
  // }
  private pickerOptions:any = {
    shortcuts: [{
      text: '今天',
      onClick(picker: any) {
        const today = new Date();
        today.setHours(0, 0, 0, 0); //
        const end = new Date(today); 
        const start = new Date(today); 
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '昨天',
      onClick(picker: any) {
        const today = new Date();
        today.setHours(0, 0, 0, 0); 
        const end = new Date(today); 
        end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
        const start = new Date(today); 
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '最近7天',
      onClick(picker: any) {
        const today = new Date();
        today.setHours(0, 0, 0, 0); 
        const end = new Date(today); 
        const start = new Date(today); 
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '最近30天',
      onClick(picker: any) {
     const today = new Date();
        today.setHours(0, 0, 0, 0); 
        const end = new Date(today); 
        const start = new Date(today); 
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        picker.$emit('pick', [start, end]);
      }
    }]
  }

  // private faultVisible  = false

  // private customer_company_pid = 0;
  // private customerLevel = 1;
  private deptArr = [{id:0,name:"顶级"}]
  private deptLevel = 1;
  //计算属性
  // get faultTypeName(){
  //   return  "备件";
  // }
  // get faultTypeNamePlaceHolder(){
  //   return  "请选择"+this.faultTypeName;
  // }
 
  // private selectFault() {
  //   this.faultVisible  = true;
  // }
  // private faultDialogClose(val: boolean) {
  //   this.faultVisible  = val;
  // }

  private pagination: any = {
    currentPage: 1,
    pageSize: 10,
    total: 0
  }

  private handleCurrentChange(page:number) {
    this.pagination.currentPage = page;
    this.getList();
  }

  private handlePageSizeChange(size: number) {
    this.pagination.pageSize = size;
    this.getList();
  }

  private loading = false
  private tableData: any = [];
  private titleData: any ={};

  private sortField = '';
  private sortRule = '';

  private handleSortChange({ prop, order }: any) {
    if (order) {
      this.sortField = prop;
      // sort_rule: 1 倒序(desc) 2 正序(asc)
      this.sortRule = order === 'descending' ? '1' : '2';
    } else {
      this.sortField = '';
      this.sortRule = '';
    }
    this.pagination.currentPage = 1;
    this.getList();
  }

  private selectedData: string[] = [];
  private handleSelected(val:any[]) {
    this.selectedData = val;
  }
  // 导出Excel
  private handleExport() {
    const pDeptId = this.deptArr[this.deptArr.length-1].id;
    let params:any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      user_name: UserModule.getUserName,
      company_name: UserModule.getCompanyName,
      // customer_company_pid: this.customer_company_pid,
      // customer_level: this.customerLevel,
      time_type: 5,
      dept_pid: pDeptId,
    };
    // let customerCompanyIds = '';
    // if (this.selectedData && this.selectedData.length > 0) {
    //   for (let i of this.selectedData) {
    //     let item:any = i;
    //     let customerId = '';
    //     if (parseInt(item.customer_company_id) === 0 || !item.customer_company_id) {
    //       customerId = 'p' + item.user_id;
    //     } else {
    //       customerId = item.customer_company_id;
    //     }
    //     customerCompanyIds = customerCompanyIds + customerId + ',';
    //   }
    //   params.customer_ids = customerCompanyIds.substring(0, customerCompanyIds.length - 1);
    // }
    // if (this.formSearch.customer && this.formSearch.customer.customer_company_id) {
    //   params.customer_company_id = this.formSearch.customer.customer_company_id;
    // }
    if (this.formSearch.timePeriods && this.formSearch.timePeriods.length === 2) {
      params.start_time = parseInt(this.formSearch.timePeriods[0]) / 1000;
      params.end_time = parseInt(this.formSearch.timePeriods[1]) / 1000;
    }
    // if (this.branchId) {
    //   params.branch_id = this.branchId;
    // }
    exportDeptSerPriceStatistics(params).then(res => {
      this.$confirm('是否跳转下载页面？', '跳转', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let routeData = this.$router.resolve({
          path: '/ExportTask',
          query: {}
        });
        window.open(routeData.href);
      }).catch(() => {

      });
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }

  // private settingColumnItem = false
  // private columnItemData: any = {
  //   all: { name: '全选', value: '0', checked: true },
  //   customer: { name: '客户', value: '1', checked: true },
  //   orderall: { name: '总订单', value: '2', checked: true },
  //   orderallBranch: { name: '分公司总订单', value: '3', checked: true },
  //   finished: { name: '已完成', value: '4', checked: true },
  //   closed: { name: '已关闭', value: '5', checked: true },
  //   operation: { name: '操作', value: '15', checked: true }
  // }
  // private showHideColumn() {
  //   this.settingColumnItem = !this.settingColumnItem;
  // }
  // private setColumnItem() {
  //   this.settingColumnItem = true;
  // }

  created() {
    // let body = document.documentElement || document.body;
    // body.addEventListener('click', (e: any) => {
    //   if (e.target.id !== 'getColumnItemBtn') {
    //     this.settingColumnItem = false;
    //   }
    // }, false);
    // this.faultType = this.$route.query && this.$route.query.faultType ? parseInt(this.$route.query.faultType as string) : 2 ;
    // this.customer_company_pid = this.$route.query && this.$route.query.customer_company_pid ? parseInt(this.$route.query.customer_company_pid as string) : 1 ;
        //获取路由参数
    // if("/Statistics/faultType"==this.$route.path){
 
    //   this.customer_company_pid = 0;
    // }else{

    //   this.customer_company_pid = 0;
    // }

    this.deptArr = [{id:0,name:"顶级"}];

    this.initTimePeriods();  

    this.getList();
  }
  private initTimePeriods(){
    let dataStrStart = new Date().getFullYear() + '/' + (new Date().getMonth() + 1) + '/' + '1 00:00:00';
    let dataStrEnd = new Date().getFullYear() + '/' + (new Date().getMonth() + 1) + '/' + new Date().getDate() + ' 23:59:59';
    this.formSearch.timePeriods = [ new Date(dataStrStart).getTime(), new Date(dataStrEnd).getTime() ];
  }
  //
  private faultSelected(fualtType:any) {
    this.formSearch.fualtType = fualtType;
  }
  private getList() {
    const pDeptId = this.deptArr[this.deptArr.length-1].id;
    let orderParams:any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      // customer_company_pid: this.customer_company_pid,
      // customer_level: this.customerLevel,
      time_type: 5,
      dept_pid: pDeptId,
      page: this.pagination.currentPage,
      size: this.pagination.pageSize
    };

    if (this.sortField) {
      orderParams.sort_field = this.sortField;
      orderParams.sort_rule = this.sortRule;
    }

    if (this.formSearch.timePeriods && this.formSearch.timePeriods.length === 2) {
      orderParams.start_time = this.formSearch.timePeriods[0] / 1000;
      orderParams.end_time = this.formSearch.timePeriods[1] / 1000;
    }


    // if (this.formSearch.customer && this.formSearch.customer.customer_company_id) {
    //   orderParams.customer_company_id = this.formSearch.customer.customer_company_id;
    // }
    // if (this.formSearch.customer && this.formSearch.customer.customer_user_id) {
    //   orderParams.customer_user_id = this.formSearch.customer.customer_user_id;
    // }
    // if (this.formSearch.name) {
    //   orderParams.name = this.formSearch.name;
    // }
    // if (this.branchId) {
    //   orderParams.branch_id = this.branchId;
    // }

    this.loading = true;
    getDeptSerPriceStatistics(orderParams).then(res => {
      if (res && res.data && res.data.list ) {

        this.titleData = res.data.titleDes;
        this.tableData = res.data.list;
    
        this.pagination.total = parseInt(res.data.count);
        this.pagination.pageSize = parseInt(res.data.page_size);

      } else {

        // this.pagination.total = 0;
        this.titleData = res.data.titleDes;
        this.tableData = [];

            
        this.pagination.total = parseInt(res.data.count);
        this.pagination.pageSize = parseInt(res.data.page_size);
        
      }
      this.loading = false;
    }).catch(err => {
      if (!err.data) {
        this.tableData = [];
        this.loading = false;
      }
      // this.showErrorMsg(err.msg);
    })
    
  }

  private handleDetail(row: any) {
    this.$router.push({
      path: '/Statistics/customerDetail',
      query: { 'customer': JSON.stringify(row) }
    });
  }

  private handleBack(){
    this.deptLevel = this.deptLevel-1;
    this.deptArr.pop() ;
    this.getList();
  }

  private handleBranch(row:any) {
    // this.branchId = row.customer_company_id;

    // this.customer_company_pid =  row.customer_company_id;
    // this.customerLevel =   this.customerLevel+1;
    this.deptLevel = this.deptLevel+1;
    this.deptArr.push({id:row.servicer_dept_id,name:row.name});
    this.pagination.currentPage = 1;
    this.getList();
  }

  private handleSearch() {
    this.pagination.currentPage = 1;
    this.getList();
  }

  private handleClear() {
    this.formSearch = {
      name: '',
      timePeriods:[],
      // customer: {}
    };
    // this.initTimePeriods();  
    
    this.pagination.currentPage = 1;
    this.pagination.total = 0;
    this.getList();
  }

  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  
}
